import React from 'react';
import classNames from 'classnames';
import s from './StackedInfoItem.scss';
import {InfoSectionDescription} from '../../../InfoSectionDescription/InfoSectionDescription';
import {InfoSectionTitle} from '../../../InfoSectionTitle/InfoSectionTitle';
import {InfoSectionLayoutId} from '../../../../../constants';
import {Cell} from '../../../../Layouts/Cell/Cell';
import {withGlobalProps, type ProvidedGlobalProps} from '../../../../../providers/globalPropsProvider';
import {SPECS} from '../../../../../specs';

export enum StackedInfoItemDataHook {
  Root = 'stacked-info-item',
}

export interface StackedInfoItemProps extends ProvidedGlobalProps {
  description: string;
  index: number;
  title: string;
}

class StackedInfoItemBase extends React.Component<StackedInfoItemProps> {
  public render(): JSX.Element {
    const {description, title, index, globals} = this.props;
    const legacyLists = !globals.useExperiments.enabled(SPECS.InfoSectionRicosGalleryListFix);

    return (
      <li className={classNames(s.container, {[s.legacyLists]: legacyLists})} data-hook={StackedInfoItemDataHook.Root}>
        <Cell className={s.stacked}>
          <InfoSectionTitle theme={InfoSectionLayoutId.Stacked} title={title} />
          <InfoSectionDescription description={description} index={index} />
        </Cell>
      </li>
    );
  }
}

export const StackedInfoItem = withGlobalProps(StackedInfoItemBase);
